module.exports = __webpack_public_path__ + "static/media/message_manager.1f466c03.svg";